/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
import React, {useState, useEffect, useCallback} from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarcode, faCalendar, faCheck, faCog, faEye, faHandHolding, faHandLizard, faHome, faPhone, faSearch, faUserShield } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Form, Button, ButtonGroup, Breadcrumb, InputGroup, Dropdown, Card, Table, Badge} from '@themesberg/react-bootstrap';
import { useDispatch, useSelector } from "react-redux"
import NewBundleSheetPage from "./NewBundleSheetPage";
import BalanceAction from "../../core/redux/action/BalanceAction";
import AppConfig from "../../core/config/AppConfig";
const moment = require('moment');
import PuPagination from "../../components/PuPagination"
import { currencyFormat } from "../../core/util/General";
import Datetime from "react-datetime";

export default (props) => {

  const [phone, setPhone] = useState()
  const [status, setStatus] = useState()
  const [accountNo, setAccountNo] = useState()
  const [barcode, setBarcode] = useState()
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()

  const dispatch = useDispatch();
  const balanceRes = useSelector((state) => state.balance);
  //const waybills = _.get(waybillRes, "waybillList.data");
  const pages = _.get(balanceRes, "transactionList.pages");
  const size = _.get(balanceRes, "transactionList.size");
  const total = _.get(balanceRes, "transactionList.total");
  const [currentPage, setCurrentPage] = useState()

  const keyPressFunction = useCallback((event) => {
    if (event.keyCode === 13) {
        fetchData()
    }
  }, [props, status, barcode, startDate, endDate,]);

  useEffect(()=>{
    if(_.get(balanceRes, 'transactionList.data') == undefined) fetchData()
  }, [])

  useEffect(() => {
    if(currentPage != undefined) fetchData()
  }, [currentPage])

  const fetchData = () => {
    dispatch(BalanceAction.getTransactions({
      input : {
        status, barcode, startDate, endDate
      },
      token : ""
    }, {
      size: AppConfig.pageSize,
      sort: "createdAt,DESC",
      page: currentPage
    }));
  };

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">          
          <h4>Transactions</h4>          
        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
          <ButtonGroup>
            <Button variant="outline-primary" size="sm">Today</Button>
            <Button variant="outline-primary" size="sm">This Week</Button>
            <Button variant="outline-primary" size="sm">This Month</Button>
          </ButtonGroup>
        </div>
      </div>

      <Card>

      <Card.Header>
          <Row>
            <Col xs={12} sm={2} xl={2}>
              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <InputGroup>
                  <Form.Select onChange={(e) => {
                    //console.log('>value', e.target.value)                        
                    setStatus(e.target.value == "--All--" ? undefined : e.target.value)
                  }}>
                    <option>--All--</option>
                    <option value={"completed"}>Completed</option>
                    <option value={"pending"}>Pending</option>                                      
                    <option value={"disputed"}>Disputed</option>                                      
                  </Form.Select>
                </InputGroup>
              </Form.Group>
            </Col>
            
            <Col xs={12} sm={2} xl={2}>
              <Form.Group className="mb-4">
                <Form.Label>Transaction#</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faBarcode} />
                  </InputGroup.Text>
                  <Form.Control required type="text" 
                    onChange={(e) => setBarcode(e.target.value == '' ? undefined : e.target.value)} />
                </InputGroup>
              </Form.Group>
            </Col>

            <Col xs={12} sm={2} xl={2}>
              <Form.Group className="mb-4">
                <Form.Label>Date Start</Form.Label>
                <Datetime
                    timeFormat={false}
                    onChange={setStartDate}
                    renderInput={(props, openCalendar) => (
                        <InputGroup>
                            <InputGroup.Text><FontAwesomeIcon icon={faCalendar} /></InputGroup.Text>
                            <Form.Control
                                required
                                type="text"
                                value={startDate ? moment(startDate).format("MM-DD-YYYY") : ""}
                                placeholder="MM-DD-YYYY"
                                onFocus={openCalendar} />
                        </InputGroup>
                    )} />
                </Form.Group>
            </Col>

            <Col xs={12} sm={2} xl={2}>
              <Form.Group className="mb-4">
                <Form.Label>Date End</Form.Label>
                <Datetime
                    timeFormat={false}
                    onChange={setEndDate}
                    renderInput={(props, openCalendar) => (
                        <InputGroup>
                            <InputGroup.Text><FontAwesomeIcon icon={faCalendar} /></InputGroup.Text>
                            <Form.Control
                                required
                                type="text"
                                value={endDate ? moment(endDate).format("MM-DD-YYYY") : ""}
                                placeholder="MM-DD-YYYY"
                                onFocus={openCalendar} />
                        </InputGroup>
                    )} />
                </Form.Group>
            </Col>

            
            
            <Col xs={12} sm={4} xl={4}>
              <Form.Group className="mb-4 float-end" style={{ paddingTop: 30 }}>
                <Button onClick={fetchData}><FontAwesomeIcon icon={faSearch} /> Search</Button>
              </Form.Group>
            </Col>
          </Row>          
        </Card.Header>
      
        <Card.Body>
          <Row>
            <Table responsive className="table-centered table-nowrap rounded mb-0">
                <thead className="thead-light">
                  <tr>
                    <th className="border-0">#</th>                                        
                    <th className="border-0">Date</th>
                    <th className="border-0">Account No</th>
                    <th className="border-0">Transaction#</th>
                    <th className="border-0">Reference No#</th>   
                    <th className="border-0">Bundle#</th>
                    <th className="border-0">Amount</th>                 
                    <th className="border-0">Status</th>
                    <th className="border-0">Payment Type</th>
                    <th className="border-0">Service Type</th>
                  </tr>
                </thead>
                <tbody>
                {
                  _.get(balanceRes, 'transactionList.data') && (
                    _.get(balanceRes, 'transactionList.data').map((item, index) =>{
                      return <tr>
                        <td>{(index + 1) + (AppConfig.pageSize * (currentPage ?? 0))}</td>                        
                        <td>{moment(_.get(item, 'createdAt')).format('MM-DD-YYY HH:mm')}</td>
                        <td>{_.get(item, 'receiver.accountNo', '')}</td>
                        <td>{_.get(item, 'transactionNo', '')}</td>
                        <td>{_.get(item, 'reference', '')}</td>
                        <td>{_.get(item, 'bundle.barcode', '')}</td>
                        <td>
                          <span>
                              <i className={`fa fa-sm ${_.get(item, 'transactionType')=='debited' ? 'fa-plus text-success' : 'fa-minus text-danger'} `}/>&nbsp;
                              { _.replace(currencyFormat(_.get(item, 'amount', '0')), '-', '') }
                            </span>                                                    
                        </td>
                        
                        <td align="center">
                          <TransactionStatus item={item} />                       
                        </td>
                        <td>{_.get(item, 'paymentType', '')}</td>
                        <td>{_.get(item, 'serviceType', '')}</td>
                      </tr>
                    })
                  )
                }
                </tbody>
              </Table>
          </Row>
        </Card.Body>

        <Card.Footer>
          <PuPagination size={size} total={total} currentPage={currentPage} totalPage={pages} onChange={setCurrentPage} />
        </Card.Footer>
      </Card>
      
    </>
  );
};

const TransactionStatus = ({ item }) => {
  switch (_.get(item, 'status')) {
    case TransactionStatusType.PENDING: return <Badge pill bg='warning' className="badge-sm mb-0 fs-8">{_.get(item, 'status')}</Badge>        
    case TransactionStatusType.COMPLETED: return <Badge pill bg='success' className="badge-sm mb-0 fs-8">{_.get(item, 'status')}</Badge>
    case TransactionStatusType.DISPUTED: return <Badge pill bg='danger' className="badge-sm mb-0 fs-8">{_.get(item, 'status')}</Badge>
    default: return <Badge pill bg='danger' className="badge-sm mb-0 fs-8">{_.get(item, 'status')}</Badge>
  }
}

const TransactionStatusType = {
  PENDING: "pending",
  COMPLETED: "completed",
  DISPUTED: "disputed",  
}

export {TransactionStatus, TransactionStatusType}
  
